import "./SmallComponent.css";
const About = () => {
  return (
    <div>
      <h3>This is About component</h3>
    </div>
  );
};
export default About;
